import './switch.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Switch = forwardRef((props, ref) => {
  const className = classNames({
    'custom-control': true,
    'custom-switch': true,
    [props.className]: props.className,
  });

  const handleOnChange = () => {
    if (props.onChange) {
      props.onChange(!props.checked);
    }
  };

  return (
    <div ref={ref} className={className}>
      <input
        id={props.switchId}
        type="checkbox"
        checked={props.checked}
        onChange={handleOnChange}
        className="custom-control-input"
      />
      <label className="label custom-control-label" htmlFor={props.switchId}>
        {props.children}
      </label>
    </div>
  );
});

Switch.propTypes = {
  switchId: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
};

Switch.defaultProps = {
  checked: false,
};

export default Switch;
